import config from 'config';
import { AnimalSpecies } from 'gql/types';

type DonorAgeRange = {
  max: number;
  min: number;
};

const donorCriteria = config.DONOR_CRITERIA;

export const DONOR_RETIREMENT_AGES: Record<AnimalSpecies, DonorAgeRange> = {
  [AnimalSpecies.Cat]: {
    min: donorCriteria.MIN_CAT_AGE,
    max: donorCriteria.CAT_RETIREMENT_AGE,
  },
  [AnimalSpecies.Dog]: {
    min: donorCriteria.MIN_DOG_AGE,
    max: donorCriteria.DOG_RETIREMENT_AGE,
  },
};

export const DEFAULT_DONOR_AGE_RANGE: DonorAgeRange = {
  min: donorCriteria.DEFAULT_MIN_DONOR_AGE,
  max: donorCriteria.DEFAULT_DONOR_RETIREMENT_AGE,
};

export function getAllowedDonorAge(species: AnimalSpecies) {
  return DONOR_RETIREMENT_AGES[species] ?? DEFAULT_DONOR_AGE_RANGE;
}

export function shouldRetireDonor(species: AnimalSpecies, age: number) {
  const range = getAllowedDonorAge(species);
  return age >= range.max;
}
